import {Entity} from './entity.model';
import {VenueRawData} from "./venues.model";

// export class SearchResultNode {
//     entity: Entity;
//     childEntity: Entity;
// }
export class SearchResultItem {
  entity: Entity;
  childEntity?: SearchResultItem;
}

// export class SearchResultTree {
//     rootEntityItem: SearchResultItem;
//     num_of_results: number;
// }

export class SearchResult {
  foundEntityItems: SearchResultItem[];
  numOfResults: number;
}

export class searchedClients {
  first: SearchStatus;
  second: {
    description: string;
    firstSeen
    lastSeen: string;
    mac: string;
    networkId: string;
    venue: VenueRawData;
  }[]
}

export enum SearchStatus {
  OK = "OK",
  FAILED = "FAILED",
  TOO_MANY_RESULTS = "To many Results"
}

export namespace SearchStatus {
  export function getFormattedSearchStatus(status: SearchStatus) {
    switch (status) {
      case SearchStatus.OK:
        return 'Ok';
      case SearchStatus.FAILED:
        return 'Failed';
      case SearchStatus.TOO_MANY_RESULTS:
        return "To Many Results"
      default:
        break;
    }

  }
}
